module.exports = __webpack_public_path__ + "static/the-ship-of-oblivion_acrylic-on-recycled-canvas-36x36in-2016-4874dad8f3ac197d0bc9690c544e01dc.jpg";